const Advanced = () => {
  return <h1>Advanced</h1>;
};
export default Advanced;
